module.exports = __webpack_public_path__ + "static/media/edit.2927f8de.svg";